import { takeLatest, call, all, put, fork } from 'redux-saga/effects'

import * as actions from '../../actions/actions'

import { campaigns, enableCampaign, disableCampaign, deleteCampaign } from "../../../api/campaignApi"
import { push } from "connected-react-router";

export default function* campaignSaga() {
  yield all([
    fork(watchFetchCampaignRequest),
    fork(watchEnableCampaignRequest),
    fork(watchDisableCampaignRequest),
    fork(watchDeleteCampaignRequest),
  ]);
}

function* watchFetchCampaignRequest() {
  yield takeLatest(
    actions.FETCH_CAMPAIGN_REQUEST,
    fetchCampaignRequest
  )
}

function* fetchCampaignRequest() {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(campaigns)
    yield put({ type: actions.FETCH_CAMPAIGN_SUCCESS, campaigns: data })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_CAMPAIGN_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchEnableCampaignRequest() {
  yield takeLatest(
    actions.ENABLE_CAMPAIGN_REQUEST,
    enableCampaignRequest
  )
}

function* enableCampaignRequest(campaignData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(enableCampaign, campaignData.value.bankId,campaignData.value.campaign)
    yield put({ type: actions.ENABLE_CAMPAIGN_SUCCESS, campaigns: data })
    yield put(push(`/campaign`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.ENABLE_CAMPAIGN_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }
  }
}

function* watchDisableCampaignRequest() {
  yield takeLatest(
    actions.DISABLE_CAMPAIGN_REQUEST,
    disableCampaignRequest
  )
}

function* disableCampaignRequest(campaignData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(disableCampaign,campaignData.value.bankId, campaignData.value.campaign)
    yield put({ type: actions.DISABLE_CAMPAIGN_SUCCESS, campaigns: data })
    yield put(push(`/campaign`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.DISABLE_CAMPAIGN_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }
  }
}

function* watchDeleteCampaignRequest() {
  yield takeLatest(
    actions.DELETE_CAMPAIGN_REQUEST,
    deleteCampaignRequest
  )
}

function* deleteCampaignRequest(bank) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(deleteCampaign,bank.value.bankId, bank.value.campaign)
    yield put({ type: actions.DELETE_CAMPAIGN_SUCCESS, campaigns: data })
    yield put(push(`/campaign`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.DELETE_CAMPAIGN_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }
  }
}